import { ApiEnvironments } from '../../../../../common/enums';
import { envConfig } from '../../../../../configs/env';
import { DateTimeFormatter } from '../../../../../formatters';
import useDebugFeatures from '../../../../../hooks/use-debug-features';
import { useMapSourceSettings } from '../../../../hooks/use-map-settings';
import SettingsInfoElement from '../base/elements/SettingsInfoElement';

export function SettingsAbout() {
    const debug = useDebugFeatures();
    const mapSettings = useMapSourceSettings();

    return (
        <>
            {debug && <SettingsInfoElement element={{ type: 'text', name: 'Environment', hint: ApiEnvironments[envConfig.type] }} />}
            {debug && <SettingsInfoElement element={{ type: 'text', name: 'Service', hint: envConfig.service }} />}
            {debug && <SettingsInfoElement element={{ type: 'text', name: 'FE-Server', hint: envConfig.ws }} />}

            <SettingsInfoElement
                element={{ type: 'text', name: 'Base map build date', hint: DateTimeFormatter.formatDate(mapSettings.base.buildDate) }}
            />
            <SettingsInfoElement
                element={{
                    type: 'text',
                    name: 'Nav data version',
                    hint: debug
                        ? `${DateTimeFormatter.formatDate(mapSettings.nav.cycleDate)}, seq: ${mapSettings.nav.sequence}, version: ${mapSettings.nav.version}`
                        : DateTimeFormatter.formatDate(mapSettings.nav.cycleDate)
                }}
            />
        </>
    );
}

/*
                {
                    type: 'text',
                    name: 'Service',
                    hint: 'https://services-dev.flightexplorer.com/api/v1/'
                },
                {
                    type: 'text',
                    name: 'Base map build date',
                    hint: '05/05/2025'
                },
                {
                    type: 'text',
                    name: 'Nav data version',
                    hint: 'Cycle: 11/27/2025, Build: 12/02/2025 14:03:00Z'
                }
*/
